/**
 * Main transform orchestrator for HTML to React conversion
 */

import { parseHtml } from './parser';
import { renderAst } from './renderer';
import { renderAstWithHighlights } from './highlighter';
import { Annotation } from '../../Annotation/types';

/**
 * Main transformation function with highlighting support.
 */
export function transformContent(
  htmlString: string,
  annotations: Annotation[],
  { renderHighlights = false }: { renderHighlights?: boolean } = {},
): React.ReactNode[] {
  const parsedDoc = parseHtml(htmlString);
  const shouldRenderHighlights = renderHighlights && annotations.length > 0;

  if (!shouldRenderHighlights) {
    return renderAst(parsedDoc.ast);
  }

  return renderAstWithHighlights(
    parsedDoc.ast,
    parsedDoc.textRunLookup,
    annotations,
  );
}
